import {jsx,jsxs}from'react/jsx-runtime';import {usePrivy,useWallets,PrivyProvider}from'@privy-io/react-auth';import {useSetActiveWallet,WagmiProvider}from'@privy-io/wagmi';import {useSmartWallets,SmartWalletsProvider}from'@privy-io/react-auth/smart-wallets';import {useAccount as useAccount$1,useAccountEffect}from'wagmi';import {useRef,useMemo,createContext,useContext,useState,useEffect}from'react';function FixSocialLogin() {
    const { ready, authenticated, logout } = usePrivy();
    const { address, isConnecting, isReconnecting } = useAccount$1();
    const { wallets } = useWallets();
    const { setActiveWallet } = useSetActiveWallet();
    const isProcessingLogoutRef = useRef(false);
    useAccountEffect({
        onDisconnect: () => {
            isProcessingLogoutRef.current = true;
            if (authenticated) {
                logout()
                    .catch(() => { })
                    .finally(() => {
                    isProcessingLogoutRef.current = false;
                });
            }
        },
    });
    useMemo(() => {
        if (!address && !isConnecting && !isReconnecting && ready && wallets?.[0] && !isProcessingLogoutRef.current) {
            setActiveWallet(wallets[0]);
        }
    }, [wallets?.[0], address, isConnecting, isReconnecting, ready]);
    return null;
}const ExtendedAccountContext = createContext(null);
const useAccount = () => {
    return useContext(ExtendedAccountContext);
};
const ExtendedAccountProvider = ({ children }) => {
    const account = useAccount$1();
    const privy = usePrivy();
    const [hasReconnectionFired, setHasReconnectionFired] = useState(false);
    const additionalContext = useMemo(() => {
        if (!account.address || privy?.user?.smartWallet?.smartWalletType !== 'safe') {
            // workaround for broken initial state from privy-io/wagmi
            if (!hasReconnectionFired && account.status === 'disconnected') {
                return {
                    ...account,
                    status: 'reconnecting',
                    isDisconnected: false,
                    isReconnecting: true,
                    isAAWallet: false,
                    isReady: false,
                };
            }
            return {
                ...account,
                isAAWallet: false,
                isReady: privy.ready
            };
        }
        return {
            ...account,
            address: privy.user.smartWallet.address,
            isAAWallet: true,
            isReady: privy.ready
        };
    }, [account, account.address, privy?.user?.smartWallet?.address, privy.ready]);
    // workaround for broken initial state from privy-io/wagmi
    useEffect(() => {
        if (hasReconnectionFired) {
            return;
        }
        if (account.status !== 'disconnected') {
            setHasReconnectionFired(true);
            return;
        }
        const timer = setTimeout(() => {
            setHasReconnectionFired(true);
        }, 7000);
        return () => {
            clearTimeout(timer);
        };
    }, [account.status]);
    return (jsx(ExtendedAccountContext.Provider, { value: additionalContext, children: children }));
};const AAWalletClientProviderContext = createContext(undefined);
const useAAWalletClient = () => {
    return useContext(AAWalletClientProviderContext);
};
const AAWalletClientProvider = ({ children }) => {
    const { client } = useSmartWallets();
    return (jsx(AAWalletClientProviderContext.Provider, { value: client, children: children }));
};const loginMethods = ['wallet', 'email', 'google', 'twitter', 'farcaster', 'discord', 'instagram'];
const Provider = (props) => {
    const { children, appId, privyConfig, wagmiConfig, initialWagmiState, paymasterContext } = props;
    const { embeddedWallets, ...restConfig } = privyConfig;
    return (jsx(PrivyProvider, { appId: appId, config: {
            loginMethods,
            ...restConfig,
            embeddedWallets: {
                createOnLogin: 'users-without-wallets',
                requireUserPasswordOnCreate: false,
                // waitForTransactionConfirmation: false,
                showWalletUIs: false,
                ...embeddedWallets || {},
            },
        }, children: jsx(SmartWalletsProvider, { config: { paymasterContext }, children: jsxs(WagmiProvider, { config: wagmiConfig, initialState: initialWagmiState, reconnectOnMount: false, children: [jsx(FixSocialLogin, {}), jsx(ExtendedAccountProvider, { children: jsx(AAWalletClientProvider, { children: children }) })] }) }) }));
};export{AAWalletClientProviderContext,Provider as PrivyProvider,useAAWalletClient,useAccount};